import React from 'react';
import * as styles from './styles.scss';

const Column = ({ children, mb, mt, className }) => (
  <div className={`${styles.column}${mb ? ` ${styles.mb}` : ''}${mt ? ` ${styles.mt}` : ''}${className ? ` ${className}` : ''}`}>
      {children}
  </div>
);

export default Column;
